import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import Component from 'vue-class-component';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import axios from 'axios';
import qs from 'qs';

import App from './App.vue';

import './filters';

import './validate';
import './ui-kit';

import store from './store';
import router from './router';
import { LOGOUT, AUTH_CHECK } from './store/actions'; // LOGOUT,
import { ROUTE_CHANGED } from './store/mutation-types';

import heartbeat from './helpers/heartbeat.helper';

import get from 'lodash/get';

import { GA_KEY } from './config';

const UNAUTH_CODE = 401;

// Register the router hooks with thier names
Component.registerHooks([
   'beforeRouteEnter',
   'beforeRouteLeave',
]);

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Vuelidate);

axios.interceptors.request.use((config) => {
   config.paramsSerializer = (params) => qs.stringify(params, {arrayFormat: 'repeat'});
   return config;
});

axios.interceptors.response.use((ctx) => {
   heartbeat.ping();
   return ctx;
}, (err) => {
   const response = err.response;
   if ( response.status === UNAUTH_CODE && get(store, 'state.auth.isAuth', false)) {
      store.dispatch(LOGOUT);
   }

   return Promise.reject(err.response.data);
});


store.dispatch(AUTH_CHECK).then(() => {
   Vue.use(VueAnalytics as any, {
      id: store.state.settings.gaid || GA_KEY,
      router,
      autoTracking: {
         pageviewOnLoad: true,
         exception: true,
      },
   });
});

router.afterEach((to: Route) => {
   store.commit(ROUTE_CHANGED, to.fullPath);
});

new Vue({
   store,
   router,
   render: (h) => h(App as any),
}).$mount('#app');

(window as any).embedHFWidget();
